<template>
  <modal name="onboarding" width="100%" height="100%" classes="onboarding" class="onboarding">
      <div class="onboarding__inner" v-if="activeStep">
        <div class="onboarding__image">
          <PolygonSvg :icon="getSvg" />
        </div>
        <h1>{{ activeStep.title }}</h1>
        <p>{{ activeStep.text }}</p>

        <button class="button--secondary" :class="{ 'is-loading': loading }" @click="goToNextStepOrFinish">
          {{ buttonText }}<i></i>
        </button>
        <!-- <ul class="onboarding__paging">
          <li v-for="(step, i) in steps" :key="i" :class="{ 'is-active': step === activeStep }">
            <i class="hidden">{{ $t('errand.page') }} {{ i+1 }}</i>
          </li>
        </ul> -->
      </div>
  </modal>
</template>

<script>
import rpcService from '@/core/services/rpc-service'
import _ from 'lodash'

export default {
  data: () => ({
    loading: false,
    activeStep: null
  }),
  mounted() {
    this.$modal.show('onboarding')
    this.activeStep = this.steps[0]
  },
  methods: {
    toggle() {
      this.show = !this.show
    },
    goToNextStepOrFinish() {
      if (!this.isOnLastStep) {
        this.activeStep = this.steps[this.currentStepIndex + 1]
      } else {
        this.loading = true
        rpcService.completeOnboarding(this.localErrand).always(updatedErrand => {
          _.assign(this.localErrand, updatedErrand)
          this.loading = false
          this.$modal.hide('onboarding')
        })
      }
    }
  },
  computed: {
    currentStepIndex() {
      return this.steps.indexOf(this.activeStep)
    },
    buttonText() {
      return this.isOnLastStep ? this.$t('errand.complete') : this.$t('errand.continue')
    },
    isOnLastStep() {
      return this.steps.indexOf(this.activeStep) === this.steps.length - 1
    },
    steps() {
      return this.$t('errand.onboardingSteps')
    },
    getSvg() {
      return `onboarding-${this.currentStepIndex + 1}`
    }
  }
}

</script>

<style lang="scss">

.v--modal-box.onboarding {
  height: 100% !important;
  width: 100% !important;
}

.onboarding {
  z-index: 100;
  background-color: color(primary);
  display: flex;
  align-items: stretch;
  justify-content: center;
  color: color(medium);
  transition: all .2s ease-out;
  opacity: 1;

  &.is-hidden {
    transform: scale(0);
    opacity: 0;
  }
}

.onboarding__inner {
  width: 100%;
  max-width: $page-max-width;
  padding: measure(m);
  text-align: center;
  display: flex;
  flex-direction: column;
  @include layout-box;
  border-radius: 0;

  @media #{$mq-medium} {
    padding-left: 10%;
    padding-right: 10%;
  }

}

.onboarding__skip {
  margin-bottom: measure(xs);
  align-self: flex-end;
  color: color(secondary);
  @include font-size(s);
}

.onboarding__image {
  max-width: 100%;
  height: 40vh;
  margin-bottom: measure(m);
  border-radius: $border-radius-box;
  color: color(primary);

  > svg {
    height: 100%;
  }
}

.onboarding__paging {
  @include layout-list;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex-grow: 1;
  margin-bottom: measure(m);

  li {
    margin: .2em;
  }

  li::before {
    content: "";
    display: block;
    margin-left: .1em;
    margin-right: .1em;
    height: $dot-size;
    width: $dot-size;
    background-color: color(primary);
    border-radius: 50%;
  }

  li.is-active::before {
    background-color: color(primary);
  }

}

</style>
